type LoadingProps = {
  label?: string;
  /** When true, fills the viewport minus the header. Defaults to true. */
  fullscreen?: boolean;
};

export function Loading({ label = "Loading", fullscreen = true }: LoadingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={`flex flex-col items-center justify-center gap-4 ${
        fullscreen ? "min-h-[calc(100vh-4rem)]" : "py-16"
      }`}
    >
      <div className="relative h-9 w-9" aria-hidden="true">
        <div className="absolute inset-0 rounded-full border-2 border-white/[0.06]" />
        <div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-[var(--color-brand-green)]" />
      </div>
      <p className="text-[length:var(--type-data)] text-[var(--color-brand-muted)]">{label}</p>
    </div>
  );
}
